/*
 * @Author: your name
 * @Date: 2020-06-29 14:46:59
 * @LastEditTime: 2020-08-13 20:38:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fubeiapp-h5-project/src/mixins/routerPagePath.js
 */
import history from '../config/routerPageStackHistory'
import config from '../config/routerPageStackConfig'

const eventRegister = function(router) {
  const routerPush = router.push.bind(router)
  const routerGo = router.go.bind(router)
  const routerReplace = router.replace.bind(router)
  const routerBack = router.back.bind(router)
  const routerForward = router.forward.bind(router)

  router.push = (location, onResolve, onReject) => {
    console.log('push----' + 333344, location, onResolve, onReject)
    history.action = config.pushName
    if (onResolve || onReject) {
      console.log('push----' + 44444555, location, onResolve, onReject)
      return routerPush(location, onResolve, onReject)
    }
    try {
      return routerPush(location)
    } catch (error) {
      if (error !== undefined) {
        console.log(error, '路由跳转出错了')
      }
    }
  }

  router.go = n => {
    console.log('go----' + 333344, n)
    history.action = config.goName
    routerGo(n)
  }

  router.replace = (location, onResolve, onReject) => {
    console.log('replace----' + 333344, location, onResolve, onReject)
    history.action = config.replaceName
    if (onResolve || onReject) {
      return routerReplace(location, onResolve, onReject)
    }
    return routerReplace(location).catch(error => {
      if (error !== undefined) {
        console.log(error, '路由跳转出错了')
      }
    })
  }

  router.back = () => {
    console.log('back----' + 333344)
    history.action = config.backName
    routerBack()
  }

  router.forward = () => {
    console.log('forward----' + 333344)
    history.action = config.forwardName
    routerForward()
  }
}

export default eventRegister
